
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './utils/i18n';
import { useSettingsStore } from './store/useSettingsStore';

// Initialize theme on app start
const initializeTheme = () => {
  const theme = localStorage.getItem('theme') || 'dark';
  if (theme === 'light') {
    document.documentElement.classList.add('light');
    document.documentElement.classList.remove('dark');
  } else {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.remove('light');
  }
};

initializeTheme();

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(<App />);
  console.log("Portfolio application started successfully!");
} else {
  console.error("Root element not found in DOM");
}
